/*=========================================================================================
	File Name: moduleAuthActions.js
	Description: Auth Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import userJson from "../../../public/user.json";
import axios from "axios";
export default {
	listRole({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/User/list/role").then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("ROLE_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},

}
